export const API_URL = "https://api.themoviedb.org/3";

export const IMAGE_BASE_URL = "http://image.tmdb.org/t/p/";

export const API_KEY = "a2bf0639421166ebc74176f0bee23258";
